import React from 'react';
import ContactFormTwo from '../components/ContactFormTwo';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get In Touch</h1>
          <p>Let's discuss how we can help grow your business</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Got a question, idea, or project? <br /> Drop us a line — we’d love to hear from you.</h2>
          <p>Whether you need a quick quote, help choosing the right service, or want to talk strategy, share a few details and we’ll come back with clear next steps — usually within one business day.</p>
          <div className="info-card">
            <h3>📧 Email</h3>
            <a href="mailto:office@marketingv8.co">office@marketingv8.co</a>
          </div>

          <div className="info-card">
            <h3>📞 Phone</h3>
            <a href="tel:+48535959510">+48 535 959 510</a>
            <p>Mon-Fri, 9am-6pm EST</p>
          </div>

          <div className="info-card">
            <h3>📍 Office</h3>
            <p>Marketing V8</p>
            <p>Rokaocin 4D</p>
            <p>83-200 Rokocin</p>
            <p>Poland</p>
            
          </div>

          <div className="info-card">
            <h3>🌐 Social Media</h3>
            <div className="social-links">
              <a href="#linkedin">LinkedIn</a>
              <a href="#twitter">Twitter</a>
              <a href="#facebook">Facebook</a>
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <ContactFormTwo />
        </div>
      </div>
    </div>
  );
}

export default Contact;
